export var StakeMode;
(function (StakeMode) {
    StakeMode["SPREAD_BETTING"] = "SPREAD_BETTING";
    StakeMode["COINS"] = "COINS";
    StakeMode["SHARES"] = "SHARES";
})(StakeMode || (StakeMode = {}));
export var InstrumentStatus;
(function (InstrumentStatus) {
    InstrumentStatus["ENABLED"] = "ENABLED";
    InstrumentStatus["CLOSE_ONLY"] = "CLOSE_ONLY";
    InstrumentStatus["DISABLED"] = "DISABLED";
})(InstrumentStatus || (InstrumentStatus = {}));
